
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"7","height":"5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.3.3c.4-.4 1-.4 1.3 0l1.9 2 1.9-2c.4-.4 1-.4 1.3 0 .4.4.4.9 0 1.3L3.5 5 .3 1.6C-.1 1.2-.1.6.3.3z"}})])
          )
        }
      }
    